export class DirectoryEdgeRecord {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "srcId",
            "baseName": "srcId",
            "type": "string",
            "format": ""
        },
        {
            "name": "srcType",
            "baseName": "srcType",
            "type": "string",
            "format": ""
        },
        {
            "name": "edgeType",
            "baseName": "edgeType",
            "type": "string",
            "format": ""
        },
        {
            "name": "dstId",
            "baseName": "dstId",
            "type": "string",
            "format": ""
        },
        {
            "name": "dstType",
            "baseName": "dstType",
            "type": "string",
            "format": ""
        },
        {
            "name": "scopeId",
            "baseName": "scopeId",
            "type": "string",
            "format": ""
        },
        {
            "name": "srcName",
            "baseName": "srcName",
            "type": "string",
            "format": ""
        },
        {
            "name": "dstName",
            "baseName": "dstName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DirectoryEdgeRecord.attributeTypeMap;
    }
    constructor() {
    }
}
